import { render } from "./taskModal.vue?vue&type=template&id=1af4447a&scoped=true&ts=true"
import script from "./taskModal.vue?vue&type=script&lang=ts"
export * from "./taskModal.vue?vue&type=script&lang=ts"

import "./taskModal.vue?vue&type=style&index=0&id=1af4447a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af4447a"]])

export default __exports__